import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "./transfer.scss";

const Controller = ({ hasAccess, transactionStep }) => {
  const screenWidth = useSelector((state) => state?.common?.screenWidth);
  const [isMobile, setIsMobile] = useState("");

  useEffect(() => {
    if (screenWidth === "md" || screenWidth === "sm" || screenWidth === "xs") {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [screenWidth]);

  return (
    <div className="w-100 mt-3">
      <div
        className={` ${isMobile
          ? " d-flex justify-content-center gap-2 "
          : "d-flex w-95 m-auto justify-content-between pb-3 border-bottom mt-4"
          }`}
      >
        <div className="d-flex light-grey">
          <h5 className={` ${hasAccess ? "unicol2" : "text-muted"}`}>
            SINGLE TRANSFER
          </h5>
        </div>
        <div className="d-flex align-items-center gap-3">
          {["step-1", "step-2", "step-3", "step-4"].map((step, index) => {
            const stepNumber = index + 1;
            const isActive =
              (transactionStep === step) ||
              (transactionStep === "step-2" && stepNumber <= 2) ||
              (transactionStep === "step-3" && stepNumber <= 3) ||
              (transactionStep === "step-4" && stepNumber <= 4);

            return (
              <div
                key={step}
                className={`rounded-circle d-flex justify-content-center align-items-center ${isActive ? "bg-unicol2 " : "bg-muted"}`}
                style={{
                  width: "30px",
                  height: "30px",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                {stepNumber}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Controller;
